import QuestionNumber from './QuestionNumber';

export default QuestionNumber;
